import { Injectable } from '@angular/core';
import { FetcherService } from '../fetcher/fetcher.service';
import { TerritoryModel, GetTerritoriesResponsePayload } from '@cpak/adp-cpak-accounts-service-models';
import { firstValueFrom, map, Observable } from 'rxjs';
import { GetUserTerritoriesResponsePayload, TerritoryAssignmentTypes } from '@cpak/adp-cpak-users-service-models';

@Injectable({
  providedIn: 'root',
})
export class TerritoriesService {
  constructor(private fetcher: FetcherService) {}

  public getTerritoriesForAccount(
    accountId: string,
    limit: number,
    offset: number,
    withParents = false
  ): Observable<TerritoryModel[]> {
    return this.fetcher
      .get<GetTerritoriesResponsePayload>(`/api/territories`, { accountId, limit, offset, withParents })
      .pipe(
        map(response => response?.data.territories || []),
        map(territories => territories.sort((a, b) => a.name.localeCompare(b.name)))
      );
  }

  public async getTerritoriesForAccountService(
    accountId: string,
    limit: number,
    offset: number,
    withParents = false
  ): Promise<TerritoryModel[]> {
    const response = await firstValueFrom(
      this.fetcher.get<GetTerritoriesResponsePayload>(`/api/territories`, { accountId, limit, offset, withParents })
    );
    const territories = response?.data.territories || [];
    return territories.sort((a, b) => a.name.localeCompare(b.name));
  }

  public getTerritories(
    countryIds: string | string[],
    topLevelOnly: boolean = false
  ): Observable<GetTerritoriesResponsePayload | null> {
    return this.fetcher.get(`/api/territories`, { countryIds, topLevelOnly });
  }

  public getUserTerritories(
    userId: string,
    countryIds: string[] | string,
    territoryAssignmentType: TerritoryAssignmentTypes = TerritoryAssignmentTypes.all
  ): Observable<GetUserTerritoriesResponsePayload | null> {
    return this.fetcher.get(`/api/users/${userId}/territories`, { territoryAssignmentType, countryIds });
  }
}
